module.exports = __webpack_public_path__ + "img/trunk_10x3_z18.84069c7d.svg";